import { render, staticRenderFns } from "./DivorceSpouceRemarriedYN.vue?vue&type=template&id=60929196"
import script from "./DivorceSpouceRemarriedYN.vue?vue&type=script&lang=js"
export * from "./DivorceSpouceRemarriedYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports